module.exports = __webpack_public_path__ + "static/media/money.b651ade5.svg";